// extracted by mini-css-extract-plugin
export var cardContainer = "_qa-0";
export var cardHeader = "_qa-2";
export var collapsedState = "_qa-3";
export var dragHandle = "_qa-5";
export var dragHandleIcon = "_qa-6";
export var dragging = "_qa-1";
export var titleArea = "_qa-4";